export enum BonAllotGroupingOrder {
  PLAT_TOURNEE_PLC = 'PLAT_TOURNEE_PLC',
  TOURNEE_PLAT_PLC = 'TOURNEE_PLAT_PLC'
}
